

































































































































































































































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';
// @ts-ignore

// tslint:disable-next-line
const awsExport = require('../../../aws-exports').default;
@Component({})
export default class DlgMemberEdit extends Vue {
  public $refs!: {
    form: any,
    image: any,
    logo: any,
  };

  @Prop({type: Object, default: null}) private member!: any;
  @Action('members/update') private updateMember!: any;
  @Action('members/read') private readAll!: any;
  @Action('members/uploadImage') private uploadImage!: any;
  @Getter('rules/all') private rules!: any;

  private localMember: any = null;
  private items: string[] = ['Web', 'Restaurant', 'Kleidung'];
  private search: string = '';
  private dialog: boolean = false;
  private loading: boolean = false;
  private valid: boolean = true;
  private logoName: string = '';
  private imageName: string = '';
  private url: any =
    'https://s3-eu-west-1.amazonaws.com/' + awsExport.aws_user_files_s3_bucket + '/public/full/';

  @Watch('dialog')
  private onDialogChanged(val: string, oldVal: string) {
    this.localMember = JSON.parse(JSON.stringify(this.member));

    this.logoName = '- Logo -';
    this.imageName = '- Teamfoto -';
  }

  private update() {
    if (this.$refs.form.validate()) {
      this.loading = true;
      this.updateMember(this.localMember).then((res: any) => {
        this.loading = false;
        if (res) {
          this.readAll();
          this.dialog = false;
        }
      });
    }
  }

  private pickFile() {
    if (this.loading) {
      return;
    }
    this.$refs.image.click();
  }

  private pickLogo() {
    if (this.loading) {
      return;
    }
    this.$refs.logo.click();
  }

  private onFilePicked(e: any) {
    const {files} = e.target;
    if (files[0] !== undefined) {
      this.imageName = files[0].name;
      if (this.imageName.lastIndexOf('.') <= 0) {
        return;
      }
      const fr = new FileReader();
      fr.readAsDataURL(files[0]);
      fr.addEventListener('load', () => {
        this.uploadImage(files[0]).then((url: any) => {
          this.localMember.imageUrl = url;
        });
      });
    } else {
      this.imageName = '';
    }
  }

  private onLogoPicked(e: any) {
    const {files} = e.target;
    if (files[0] !== undefined) {
      this.logoName = files[0].name;
      if (this.logoName.lastIndexOf('.') <= 0) {
        return;
      }
      const fr = new FileReader();
      fr.readAsDataURL(files[0]);
      fr.addEventListener('load', () => {
        this.uploadImage(files[0]).then((url: any) => {
          this.localMember.logoUrl = url;
        });
      });
    } else {
      this.logoName = '';
    }
  }

  private generatePassword() {
    this.localMember.password = `${Math.random().toString(36).substr(2, 9)}`;
  }
}
